import { useTranslation } from 'react-i18next';

import NutritionImage from 'assets/fake-doors/nutrition.png';

type FakeDoorConfig = {
    title: string;
    description: string;
    button: string;
    image?: string;
    benefits?: {
        title: string;
        list: {
            title: string;
            description: string;
        }[];
    };
    instructions?: {
        howItWorksTitle?: string;
        list: string[];
    };
    footer?: {
        title: string;
        description: string;
        button: string;
    };
};

const fakeDoors: Record<string, FakeDoorConfig> = {
    nutrition: {
        title: 'fakeDoor.nutrition.title',
        description: 'fakeDoor.nutrition.description',
        button: 'fakeDoor.nutrition.button',
        image: NutritionImage,
        benefits: {
            title: 'fakeDoor.nutrition.benefits.title',
            list: [
                {
                    title: 'fakeDoor.nutrition.benefits.list.personalizedMealStructure.title',
                    description: 'fakeDoor.nutrition.benefits.list.personalizedMealStructure.description',
                },
                {
                    title: 'fakeDoor.nutrition.benefits.list.dailyGuidedMeals.title',
                    description: 'fakeDoor.nutrition.benefits.list.dailyGuidedMeals.description',
                },
                {
                    title: 'fakeDoor.nutrition.benefits.list.nutritionTracking.title',
                    description: 'fakeDoor.nutrition.benefits.list.nutritionTracking.description',
                },
                {
                    title: 'fakeDoor.nutrition.benefits.list.calorieMacroTargets.title',
                    description: 'fakeDoor.nutrition.benefits.list.calorieMacroTargets.description',
                },
                {
                    title: 'fakeDoor.nutrition.benefits.list.adaptedToLifestyle.title',
                    description: 'fakeDoor.nutrition.benefits.list.adaptedToLifestyle.description',
                },
            ],
        },
        instructions: {
            howItWorksTitle: 'fakeDoor.nutrition.instructions.howItWorksTitle',
            list: [
                'fakeDoor.nutrition.instructions.list.step1',
                'fakeDoor.nutrition.instructions.list.step2',
                'fakeDoor.nutrition.instructions.list.step3',
            ],
        },
        footer: {
            title: 'fakeDoor.nutrition.footer.title',
            description: 'fakeDoor.nutrition.footer.description',
            button: 'fakeDoor.nutrition.footer.button',
        },
    },
    fitness: {
        title: 'fakeDoor.fitness.title',
        description: 'fakeDoor.fitness.description',
        button: 'fakeDoor.fitness.button',
        image: '',
    },
};

export const useFakeDoor = (id: string | undefined) => {
    const { t } = useTranslation();

    if (!id) {
        return undefined;
    }

    const config = fakeDoors[id];

    if (!config) {
        return undefined;
    }

    return {
        title: t(config.title),
        description: t(config.description),
        button: t(config.button),
        image: config.image,
        benefits: {
            title: t(config.benefits?.title || ''),
            list: config.benefits?.list.map((item) => ({
                title: t(item.title),
                description: t(item.description),
            })),
        },
        instructions: {
            howItWorksTitle: t(config.instructions?.howItWorksTitle || ''),
            list: config.instructions?.list.map((item) => t(item)) || [],
        },
        footer: {
            title: t(config.footer?.title || ''),
            description: t(config.footer?.description || ''),
            button: t(config.footer?.button || ''),
        },
    };
};
